import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { DELETED_CONTACT_AVATAR_INFO, type IAvatarInfo } from 'shared/ui'
import { Tag } from 'entities/Tags/model/Tag'
import { type IReviewContact } from 'entities/Review/api/types'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'

export class ReviewContactRow extends RowBase<IReviewContact> {
  readonly tags: Tag[]

  constructor(origin: IReviewContact) {
    super(origin)
    this.tags = Array.isArray(origin.tags) ? origin.tags.map(Tag.Create) : []
    makeObservableRowBase(this)

    if (origin.contact_id === null) {
      this.setCheckboxDisabled(true)
    }

    if (origin.archived_at) {
      this.setDisabled(true)
      this.setCheckboxDisabled(true)
    }
  }

  get isDeleted() {
    return Boolean(this.origin.archived_at)
  }

  get contactId() {
    return this.origin.contact_id
  }

  get comment() {
    return this.origin.comment
  }

  get createdAt() {
    return this.origin.created_at
  }

  get formattedNumber() {
    return this.origin.formatted_number
  }

  get firstName() {
    return this.origin.first_name
  }

  get lastName() {
    return this.origin.last_name
  }

  get fullName() {
    return this.origin.full_name
  }

  get rate() {
    return this.origin.rate
  }

  get shortUrlLastClickedAt() {
    return this.origin.short_url_last_clicked_at
  }

  get lastClickedAt() {
    return this.origin.last_clicked_at
  }

  get color() {
    return getUserAvatarColor(this.origin.id)
  }

  get avatarInfo(): IAvatarInfo {
    if (this.isDeleted) {
      return DELETED_CONTACT_AVATAR_INFO
    }

    const isPhoneAbbr = !this.origin.first_name && !this.origin.last_name

    return {
      isPhoneAbbr,
      firstName: this.origin.first_name || '',
      lastName: this.origin.last_name || '',
      image: this.origin.photo_url || '',
      color: this.color,
      number: this.formattedNumber || '',
    }
  }
}
